import { ChangeDetectorRef, Component, effect, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { LoadingService } from './core/components/loading/loading.service';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';
import { NavigationRoutesService } from './app.navigation_routes.service';
import { TabMonitorService } from './services';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  loading: boolean = false; // Add the loading property
  currentUrl = ''
  parentRoute = ''
  childRoute = ''

  // Email Notification Properties
  showEmailNotice: boolean = false;
  currentNoticeLanguage: 'en' | 'si' = 'en';

  constructor(
    private router: Router,
    private authService: AuthService,
    private loadingService: LoadingService,
    private cdr: ChangeDetectorRef,
    private navigationRoutesService: NavigationRoutesService,
    private tabMonitorService: TabMonitorService,
  ) {
    effect(() => {
      this.isFullPage = this.navigationRoutesService.navHideState()
    })
  }

  ngOnInit() {

    this.tabMonitorService.init();
    this.tabMonitorService.onCloseOpenedTab()
    let appEnvironment = environment.production
    if (!appEnvironment) {
      console.log("--- App runs on DEVELOPMENT ---")
    }

    const fullScreenPages = ["/login", "/dashboards/sales"]

    this.loading = false;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const currentRoute = this.router.url;
        this.currentUrl = currentRoute

        if (fullScreenPages.includes(currentRoute)) {
          // this.isFullPage = true
          this.navigationRoutesService.navHideState.set(true)
        }
        else {
          // this.isFullPage = false
          this.navigationRoutesService.navHideState.set(false)
        }
      }
    });

    // this.isFullPage = true
    this.navigationRoutesService.navHideState.set(true)

    this.loadingService.isLoading.subscribe((isLoading) => {
      setTimeout(() => {
        this.loading = isLoading;
        this.cdr.detectChanges();  // Manually trigger change detection
      }, 10);
    });

    // Check if the email notification needs to be shown
    this.checkEmailNotice();
  }

  checkEmailNotice() {
    const isDismissed = localStorage.getItem('savinda_email_notice_seen');
    if (!isDismissed) {
      this.showEmailNotice = true;
    }
  }

  dismissEmailNotice() {
    this.showEmailNotice = false;
    localStorage.setItem('savinda_email_notice_seen', 'true');
    this.cdr.detectChanges();
  }

  selectNoticeLanguage(lang: 'en' | 'si') {
    this.currentNoticeLanguage = lang;
    this.cdr.detectChanges();
  }




  // pdfResponseUrl = 'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf'
  pdfResponseUrl = '../assets/reports/report.pdf'

  isUserAuthenticated: string = 'true';
  isFullPage: boolean = true;

  logOutUser() {
    this.authService.logout()
  }

  isMenuOpened: boolean = false
  openMenu = () => {
    this.isMenuOpened = !this.isMenuOpened
  }

  closeTopMenu() {
    if (this.isMenuOpened) {
      this.isMenuOpened = !this.isMenuOpened
    }
  }

  activateChildRoute(childRoute: string) {
    let parentRoute = this.getBaseRoute()
    let fullChildRoute = 'unauthorized'
    if (parentRoute === '') {
      fullChildRoute = 'unauthorized'
    } else {
      fullChildRoute = `${parentRoute}/${childRoute}`
    }
    this.router.navigate([`${fullChildRoute}`]);
  }

  private getBaseRoute(): string {
    const segments = this.currentUrl.split('/');
    if (segments.length >= 2) {
      const baseRoute = segments[1]; // Index 0 is an empty string due to leading '/'
      return baseRoute
    } else {
      return ''
    }
  }

  isUserMenuOpened = false
  openUserMenu() {
    this.isUserMenuOpened = true
  }
  closeUserMenu() {
    this.isUserMenuOpened = false
  }

  goHome() {
    // this.router.navigate(['dashboards/common'])
    this.navigationRoutesService.navHideState.set(false)
  }
}
